import React, { useEffect, Fragment } from "react";
import { useWatch } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { validateRslice } from '../../../../config/validations';


const RsliceSliceSelector = (props) => {
	const { control, register, reset, configurations, savedConfig, errors, getValues } = props;

	const configurationId = useWatch({
		control,
		name: "configurationId",
		defaultValue: "",
	});

	console.log(configurationId, 'config id');

	useEffect(() => {
		if (configurationId) {
			console.log({savedConfig, configurations});
			if (savedConfig && savedConfig?.configurationId === configurationId){
				reset({ configurationId, rslice: savedConfig.rslice || "s", sslice: savedConfig.sslice || "R" });
				return
			}

			const selected = configurations.find((i) => i._id === configurationId);
			
			if (!selected) return;
			reset({ configurationId, rslice: selected.rslice || "s", sslice: selected.sslice || "R" });
		}
	}, [configurationId, savedConfig]);

	useEffect(() => {
		if(savedConfig && (!configurationId || configurationId === '')){
			reset(savedConfig)
		}
	},[savedConfig])

	if (!Boolean(configurationId)) return <Fragment />;

	return (
		<Fragment>
			<Grid item xs={6}>
				<TextField
					InputLabelProps={{
						shrink: true,
					}}
					type={"text"}
					fullWidth
					required
					label={"Resource Slice"}
					placeholder={"Resource Slice"}
					variant="outlined"
					name={"rslice"}
					inputRef={register({ required: true, validate: validateRslice })}
					error={errors?.rslice ? true : false}
                    helperText={(getValues('rslice') == '' && errors.rslice) ? 'Field is required' : errors.rslice ? 'Invalid resource slice': ''}
				/>
			</Grid>
			<Grid item xs={6}>
				<TextField
					InputLabelProps={{
						shrink: true,
					}}
					type={"text"}
					fullWidth
					required
					label={" Service Slice"}
					placeholder={"Service Slice"}
					variant="outlined"
					name={"sslice"}
					error={errors?.sslice ? true : false}
					inputRef={register({ required: true })}
					helperText={(getValues('sslice') == '' && errors.sslice) ? 'Field is required': ''}
				/>
			</Grid>
		</Fragment>
	);
};


export default RsliceSliceSelector;